// extracted by mini-css-extract-plugin
export default {"groceries":"Groceries_groceries__Hmc0s"};